import { CSSObject } from '@chakra-ui/react';

export const SideNavHeading: CSSObject = {
  fontFamily: 'KHInterference',
  fontWeight: 'normal',
  fontSize: 'lg',
  textTransform: 'uppercase',
  color: 'white',
  letterSpacing: 'widest',
  px: '2',
  pt: '0',
  pb: '1',
  lineHeight: 'none',
  height: '40px',
  alignItems: 'end',
};
